import { useEffect, useRef, useState } from "react";

import fallback_img from "./img/fallback_img.jpg"

import loading_img from "./img/loadingImg.jpg"
import { useDispatch } from "react-redux";
import ThankYouWithCTA from "./LeadThankYouPopUp";
const LeadInfoCardTheme1 =({leadThemeObject,onSubmit,
onSuccess,
submitText = leadThemeObject?.buttonText?.title,
showMessageField =  leadThemeObject?.message?.status,
theme = "light",
autoFocus = false,
className = ""
,status,setStatus
})=> {  
const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    message: "",
    source: "website",
    consent: false,
    hp: "", // honeypot field
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const nameRef = useRef(null);

  const ids = {
    name: "lf-name",
    email: "lf-email",
    phone: "lf-phone",
    company: "lf-company",
    message: "lf-message",
    consent: "lf-consent",
    source: "lf-source",
    hp: "lf-hp",
  };

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneRegex = /^\+?[0-9\s-]{6,15}$/;

  const validate = () => {
    const e = {};
    if (!form.name.trim()&&leadThemeObject?.fullname?.status) e.name = "Name is required";
    if (!form.email.trim()) e.email = "Email is required";
    if (form.email.trim() && !emailRegex.test(form.email.trim())) e.email = "Enter a valid email";
    if (form.phone && !phoneRegex.test(form.phone)) e.phone = "Enter a valid phone";
    if (!form.consent&&leadThemeObject?.checkBoxText?.status) e.consent = "Please agree to be contacted";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleChange = (k) => (ev) => {
    const val = ev?.target?.type === "checkbox" ? ev.target.checked : ev.target.value;
    setForm((s) => ({ ...s, [k]: val }));
    setErrors((prev) => ({ ...prev, [k]: undefined }));
  };

  const defaultOnSubmit = async (payload) => {
    // simulate network
    await new Promise((r) => setTimeout(r, 700));
    return { success: true, message: "Thanks — we received your request." };
  };

  const submitHandler = async (ev) => {
    ev?.preventDefault();

    // basic spam check: honeypot filled
    if (form.hp) return; // silently ignore

    // trim string fields
    const payload = {
      ...form,
      name: form.name.trim(),
      email: form.email.trim(),
      phone: form.phone.trim(),
      company: form.company.trim(),
      message: form.message.trim(),
    };

    setStatus(null);
    if (!validate()) return;

    setLoading(true);
    try {
      const fn = onSubmit || defaultOnSubmit;
      const res = await fn({ ...payload, submittedAt: new Date().toISOString() });
      if (res && res.success) {
        setStatus({ type: "success", text: res.message || "Submitted successfully" });
        setForm({ name: "", email: "", phone: "", company: "", message: "", source: "website", consent: false, hp: "" });
        setErrors({});
        if (onSuccess) onSuccess(res);
      } else {
        setStatus({ type: "error", text: (res && res.message) || "Submission failed. Try again." });
      }
    } catch (err) {
      setStatus({ type: "error", text: err?.message || "Submission failed" });
    } finally {
      setLoading(false);
    }
  };

  // optional: autofocus
 useEffect(() => {
    if (autoFocus && nameRef.current) nameRef.current.focus();
  }, [autoFocus]);

  // prevent Enter key from submitting when focus is on textarea
  const handleKeyDown = (ev) => {
    if (ev.key === "Enter") {
      const tag = ev.target.tagName;
      if (tag === "TEXTAREA") return; // let newline
    }
  };

const ImageWithFallback = ({ src ,leadThemeObject,widthOuter,fireOpenEdit,iconSize,setOpenFullImg}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  
  
     const dispatch = useDispatch();  
   const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
          {
            
            dispatch({type: "CURSOR",payload:true  });
        
            dispatch({type: "CURSORTEXT",payload:CursorText})
            dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
            dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
          }
           
          const handleMouseLeave = () => {
            
            dispatch({type: "CURSOR",payload:false})
        
            dispatch({type: "CURSORTEXT",payload:""})
        
            dispatch({type: "CURSORTEXTBG",payload:""})
            dispatch({type: "CURSORTEXTCOLOR",payload:""})
          
        
        }
          
     
  return (<div>
     <div  className="hoverFBackImgEdit"
      style={{ marginTop: "15px",marginBottom: "15px",
         borderTopLeftRadius:`${leadThemeObject?.image?.borderRadius?.topLeft?.value}${leadThemeObject?.image?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${leadThemeObject?.image?.borderRadius?.topRight?.value}${leadThemeObject?.image?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${leadThemeObject?.image?.borderRadius?.bottomLeft?.value}${leadThemeObject?.image?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${leadThemeObject?.image?.borderRadius?.bottomRight?.value}${leadThemeObject?.image?.borderRadius?.bottomRight?.resolution}`,
        width: widthOuter,
        aspectRatio: leadThemeObject?.image?.aspectRatio?.value ,
           border:leadThemeObject?.borderImage?.borderWidth?.value+"px "+ leadThemeObject?.borderImage?.borderType +" "+leadThemeObject?.borderImage?.borderColor?.color,
     
        position: "relative",
        overflow: "hidden",
      }}

      onClick={()=>{fireOpenEdit() ;setOpenFullImg()}}
    >
    

      {!isLoaded && !hasError && (
        <img
        src={loading_img}
        alt=""
      style={{
          borderRadius: "10px",
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          marginTop: "0px",border:"0px solid rgba(144, 202, 249,1)",
      
          }}
      />
      )}
    
      <img
        src={hasError ? fallback_img : src}
        alt=""
        onLoad={() => setIsLoaded(true)}
        onError={() => setHasError(true)}
        style={{
          borderRadius: "10px",
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          marginTop: "0px",border:"0px solid rgba(144, 202, 249,1)",
        //   display: isLoaded && !hasError ? "block" : "none",
        }}
      />
    </div>
    
    </div>
  );
};
return (<>{status && (
          // <div className={`lf-status ${status.type === "success" ? "lf-success" : "lf-error"}`} role="status">
          //   {status.text}
          // </div>
          <ThankYouWithCTA leadThemeObject={leadThemeObject}  redirectToDashboard={()=>{setStatus(false)}} />
        )}
   <div className={`lf-wrapper ${className}`}>
   {leadThemeObject?.image?.status? <div className="lf-left-card" >
      <h3 className="lf-title">{leadThemeObject?.image?.title}</h3>
     
           <div  style={{display:"flex",justifyContent:"center",alignItems:"center",}}>
           
        
 <ImageWithFallback  leadThemeObject={leadThemeObject}  src={leadThemeObject?.image?.src} widthOuter={"270px"} fireOpenEdit ={()=>{}}  iconSize={44}  setOpenFullImg={()=>{}}/>
         
    </div> </div> :""}
      <form className="lf-card" onSubmit={submitHandler} aria-label="Lead capture form">
        <div className="lf-header">
          <div>
            <h3 className="lf-title">{leadThemeObject?.formTitle?.title}</h3>
            <p className="lf-sub">{leadThemeObject?.formTitle?.subtitle}</p>
          </div>
          <div className="lf-tag">{leadThemeObject?.formTitle?.info}</div>
        </div>

        

        <div className="lf-grid">
            {leadThemeObject?.fullname?.status?
          <label className="lf-field">
            <span className="lf-label">{leadThemeObject?.fullname?.title} </span>
            <input value={form.name} onChange={handleChange("name")} placeholder={leadThemeObject?.fullname?.placeholder} aria-invalid={!!errors.name} className="lf-input" />
            {errors.name && <small className="lf-err">{errors.name}</small>}
          </label>:""}

          <label className="lf-field">
            <span className="lf-label">{leadThemeObject?.email?.title} (required)</span>
            <input value={form.email} onChange={handleChange("email")} placeholder={leadThemeObject?.email?.placeholder} aria-invalid={!!errors.email} className="lf-input" />
            {errors.email && <small className="lf-err">{errors.email}</small>}
          </label>
      {leadThemeObject?.mobile?.status?
          <label className="lf-field">
            <span className="lf-label">{leadThemeObject?.mobile?.title} (optional)</span>
            <input value={form.phone} onChange={handleChange("phone")} placeholder={leadThemeObject?.mobile?.placeholder} className="lf-input" />
            {errors.phone && <small className="lf-err">{errors.phone}</small>}
          </label>:""} 
            {leadThemeObject?.city?.status?
          <label className="lf-field">
            <span className="lf-label">{leadThemeObject?.city?.title} </span>
            <input value={form.city} onChange={handleChange("city")} placeholder={leadThemeObject?.city?.placeholder} className="lf-input" />
            {errors.city && <small className="lf-err">{errors.city}</small>}
          </label>:""}

          {/* <label className="lf-field">
            <span className="lf-label">Company (optional)</span>
            <input value={form.company} onChange={handleChange("company")} placeholder="Company name" className="lf-input" />
          </label> */}
        </div>
        {showMessageField && (
          <label className="lf-field lf-message">
            <span className="lf-label">{leadThemeObject?.message?.title}</span>
            <textarea value={form.message} onChange={handleChange("message")} placeholder={leadThemeObject?.message?.placeholder} rows={4} className="lf-input lf-textarea" />
          </label>
        )}
{leadThemeObject?.checkBoxText?.status?
        <div className="lf-row">
          <label className="lf-consent">
            <input type="checkbox" checked={form.consent} onChange={handleChange("consent")} />
            <span className="lf-consent-text">{leadThemeObject?.checkBoxText?.title}</span>
          </label>

        </div>:""}
        {errors.consent && <small className="lf-err">{errors.consent}</small>}

        <div className="lf-actions" style={{display:"flex",justifyContent:"right"}}>
          <button className="lf-btn" type="submit" disabled={loading}>
            {loading ? "Sending..." : submitText}
          </button>
{/* 
          <button
            type="button"
            className="lf-reset"
            onClick={() => {
              setForm({ name: "", email: "", phone: "", company: "", message: "", source: "website", consent: false });
              setErrors({});
              setStatus(null);
            }}
          >
            Reset
          </button> */}
        </div>

       
      </form>
    </div>
      <style>{ `
      
      .videoPlayerPopUpBackDrop-${leadThemeObject?.myKey}{position:fixed;top:0px;
        left:0px;
        right:0px;
       
        bottom:0px;
        padding:15px;
        background:rgba(1, 1, 1,0.661);
        z-index:99999999 !important}

       

/* Basic layout */

.lf-wrapper { padding: 16px; display: flex;  flex-direction: row; justify-content:center ;}
.lf-left-card{
 background:${leadThemeObject?.layoutBGLeft?.color}; margin:10px; width:40%;max-width: 360px;
 border-radius: 16px; padding: 20px; 
 color: #0f1724; 
}
.lf-card { width: 100%; margin:10px; max-width: 720px; background: ${leadThemeObject?.layoutBGRight?.color}; border-radius: 16px; padding: 20px; box-shadow: 0 6px 22px rgba(18, 24, 37, 0.06);
 color: #0f1724; font-family:${leadThemeObject?.titleFont?.family?.fontFamily}; }

.lf-header { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 12px;font-family:"${leadThemeObject?.layout?.family?.fontFamily}"; }
.lf-title { margin: 0; font-size: 38px;color:${leadThemeObject?.titleColor?.color};  font-weight: 600; font-family:${leadThemeObject?.titleFont?.family?.fontFamily}; }
.lf-sub { margin: 4px 0 0 0; font-size: 13px; color:${leadThemeObject?.subtitleColor?.color};   font-family:${leadThemeObject?.subtitleFont?.family?.fontFamily};}
.lf-tag { font-size: 12px; color: ${leadThemeObject?.subtitleColor?.color};; font-family:${leadThemeObject?.subtitleFont?.family?.fontFamily};}

/* Status */
.lf-status { padding: 10px 12px; border-radius: 8px; margin-bottom: 12px; font-size: 14px; }
.lf-success { background: #f0fdf4; color: #166534; border: 1px solid #bbf7d0; }
.lf-error { background: #fffbeb; color: #92400e; border: 1px solid #fed7aa; }

/* Grid */
.lf-grid { display: grid; grid-template-columns: 1fr; gap: 12px; }
@media (min-width: 640px) { .lf-grid { grid-template-columns: 1fr 1fr; } }

.lf-field { display: flex; flex-direction: column; }
.lf-label {display: flex;align-items:left !important; font-size: 13px;
 margin-bottom: 16px;margin-top: 16px;
 color: ${leadThemeObject?.subtitleColor?.color};;font-family:${leadThemeObject?.subtitleFont?.family?.fontFamily};  }
.lf-input { padding: 10px 12px; 
  border-radius:10px;
  border:${leadThemeObject?.borderInput?.borderWidth?.value+"px "+ leadThemeObject?.borderInput?.borderType +" "+leadThemeObject?.borderInput?.borderColor?.color};
     ; background: #fbfdff; font-size: 14px; outline: none;font-family:${leadThemeObject?.subtitleFont?.family?.fontFamily}; }
.lf-input:focus { box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.08); ; }
.lf-textarea { min-height: 90px; resize: vertical; }

.lf-err { color: ${leadThemeObject?.subtitleColor?.color}; font-size: 12px;font-weight:999; margin-top: 6px; font-family:${leadThemeObject?.subtitleFont?.family?.fontFamily};}

/* consent + select */
.lf-row { display: flex; justify-content: space-between; align-items: center; gap: 12px; margin-top: 12px; }
.lf-consent { display: flex; align-items: center; gap: 8px; }
.lf-consent-text { font-size: 13px; color: ${leadThemeObject?.subtitleColor?.color};font-family:${leadThemeObject?.subtitleFont?.family?.fontFamily}; }
.lf-select { padding: 8px 10px; border-radius: 8px; border: 1px solid #e6e9ee; background: #fff; font-size: 13px; }

/* actions */
.lf-actions { display: flex; gap: 10px; align-items: right; margin-top: 14px; }
.lf-btn { background: ${leadThemeObject?.buttonBG?.color}; font-family:${leadThemeObject?.titleFont?.family?.fontFamily};
 border-top-left-radius:${leadThemeObject?.button?.borderRadius?.topLeft?.value}${leadThemeObject?.button?.borderRadius?.topLeft?.resolution};
              border-top-right-radius:${leadThemeObject?.button?.borderRadius?.topRight?.value}${leadThemeObject?.button?.borderRadius?.topRight?.resolution};
              border-bottom-left-radius:${leadThemeObject?.button?.borderRadius?.bottomLeft?.value}${leadThemeObject?.button?.borderRadius?.bottomLeft?.resolution};
              border-bottom-right-radius:${leadThemeObject?.button?.borderRadius?.bottomRight?.value}${leadThemeObject?.button?.borderRadius?.bottomRight?.resolution};
   font-size:18px;
 color: #fff;border:${leadThemeObject?.borderButton?.borderWidth?.value+"px "+ leadThemeObject?.borderButton?.borderType +" "+leadThemeObject?.borderButton?.borderColor?.color};
   padding: 14px 19px;  font-weight: 600; cursor: pointer; }
.lf-btn[disabled] { opacity: 0.7; cursor: wait; }
.lf-reset { background: transparent; border: 1px solid transparent; padding: 8px 12px; border-radius: 10px; cursor: pointer; font-size: 14px; color: #374151; }
.lf-reset:hover { background: #f8fafc; }

.lf-note { margin-top: 12px; font-size: 12px; color: #6b7280; }

/* Dark mode helper - optional: add .lf-dark on wrapper to switch */
.lf-wrapper.lf-dark .lf-card { background: #0b1220; color: #e6eef8; border-color: #111827; box-shadow: none; }
.lf-wrapper.lf-dark .lf-input { background: #071224; border-color: #1f2937; color: #e6eef8; }
.lf-wrapper.lf-dark .lf-select { background: #071224; border-color: #1f2937; color: #e6eef8; }
.lf-wrapper.lf-dark .lf-sub, .lf-wrapper.lf-dark .lf-tag, .lf-wrapper.lf-dark .lf-note { color: #9aa6b8; }

/* Small accessibility tweaks */
.lf-input:disabled, .lf-btn:disabled { cursor: not-allowed; }

/* Small accessibility tweaks */
.lf-input:disabled, .lf-btn:disabled { cursor: not-allowed; } 
/* md */
@media (min-width: 992px) and (max-width: 1199px) {
}
/* sm */
@media (min-width: 768px) and (max-width: 991px) {
}
/* xs */
@media (max-width: 767px) {

.lf-wrapper { padding: 16px; display: flex;  flex-direction: column !important; }
.lf-card,.lf-left-card { width: auto; }

}
        `}
        </style>
    </>) 
}

export default LeadInfoCardTheme1;